"use strict";
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    backdropClasses: true
};
Object.defineProperty(exports, "backdropClasses", {
    enumerable: true,
    get: function() {
        return _backdropClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Backdrop.default;
    }
});
var _Backdrop = _interopRequireDefault(require("./Backdrop"));
var _backdropClasses = _interopRequireWildcard(require("./backdropClasses"));
Object.keys(_backdropClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _backdropClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _backdropClasses[key];
        }
    });
});
